import session from "./session";
import subscription from "./subscription";
import social from "./social";
import ads from "./ads";
import matchMutation from "./matchMutation";
import prematchMutation from "./prematchMutation";

const mutations = {
  ...ads,
  ...session,
  ...subscription,
  ...social,
  ...matchMutation,
  ...prematchMutation,
  SET_ROUTE(state, route) {
    state.route = route;
  },
  setCompanies(state, { companies }) {
    state.companies = companies;
  },
};

export { mutations };
